
import React, { useEffect, useState } from "react";
import {
    Box, Button, Container, Grid, InputLabel, Stack, TextField, Typography, useTheme,
    useMediaQuery, Dialog, DialogTitle, DialogContent, DialogActions, Card, CardContent, MenuItem, Avatar
} from "@mui/material";

import BackgroundMain from "../../assets/borrower-page/BackgroundMain.svg";
import home from "../../assets/borrower-page/home.png";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import states from '../../search-mlo/states'
import { MloDetails } from '../../search-mlo/mlo-data'
import CustomAvtar from '../../search-mlo/custom-avtar'
import { ReactComponent as PhoneIcon } from "../../assets/borrower-page/PhoneIcon.svg";
import { ReactComponent as EmailIcon } from "../../assets/borrower-page/MailIcon.svg";
import { ReactComponent as WebsiteIcon } from "../../assets/borrower-page/WebsiteIcon.svg";

const useStyles = makeStyles({
    footerBGS: {
        backgroundColor: "#3d065f",
        color: "white",
        backgroundImage: "url('/images/footerBg.png')",
        backgroundRepeat: "no-repeat",
        backgroundSize: "10%",
        backgroundPosition: "left 15% bottom",
    },
});

function Banner() {


    const [Avtar, setAvtar] = useState(CustomAvtar);



    useEffect(() => {
        // const blob = new Blob([res.data], { type: 'image/png' });

        // // Create a URL for the blob
        // const imageUrl = URL.createObjectURL(blob);
        // setAvtar(imageUrl);
        // // Render the image using the URL
        // console.log(imageUrl);
        // Create a URL for the generic avatar image
        // const genericAvatarUrl = 'path_to_your_generic_avatar_image';
        setAvtar(CustomAvtar);
    }, []);


    const [open, setOpen] = useState(false);
    const [selectedState, setSelectedState] = useState("");

    const [mloDetails, setMloDetails] = useState(MloDetails);
    const [filteredMloDetails, setFilteredMloDetails] = useState([]);

    const router = useNavigate();
    const classes = useStyles();
    console.log(JSON.stringify(filteredMloDetails, null, 2))


    const handleSearch = () => {
        console.log("Selected state: ", selectedState); // Check the selected state value
        const filteredMlos = searchMloByState(selectedState);
        console.log("Filtered MLOs: ", filteredMlos); // Log the filtered MLOs
        setFilteredMloDetails(filteredMlos);
    }

    function searchMloByState(selectedState) {
        console.log("Filtering MLOs by state: ", selectedState); // Check if the function is being called
        return MloDetails.filter(mlo => mlo.state.toLowerCase() === selectedState.toLowerCase());
    }

    // Function to handle dialog close
    const handleClose = () => {
        setOpen(false);
        // Reset any state variables if needed
    };

    function searchMloByState(state) {
        return MloDetails.filter(mlo => mlo.state.toLowerCase() === state.toLowerCase());
    }



    function searchMloByState(state) {
        return mloDetails.filter(mlo => mlo.state.toLowerCase() === state.toLowerCase());
    }





    return (
        <div>
            <Container maxWidth="xl">
                <Box
                    style={{
                        position: 'relative',
                        width: '100%',
                        height: '580px', // Adjust height as needed
                    }}
                >
                    {/* Background image */}
                    <img
                        src={home}
                        alt="AmitaSoft Home"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            zIndex: -2, // Move the background image behind everything else
                        }}
                    />

                    {/* BackgroundMain image */}
                    <img
                        src={BackgroundMain}
                        alt=""
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            zIndex: -1, // Set the zIndex to be behind the overlay but above the home image
                        }}
                    />

                    {/* Background overlay */}
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 163, 254, 0.0)', // Change overlay color to match #00A3FEDB
                            zIndex: 0, // Set the zIndex to be behind the content but above the background images
                            mixBlendMode: 'multiply', // Adjust the blend mode to achieve the desired effect
                        }}
                    />

                    {/* Content */}
                    <Box
                        ml={48}
                        mr={48}
                        pt={14}
                        pb={12}
                        textAlign="center"
                        style={{
                            position: 'relative', // Ensure the content stays on top
                            zIndex: 1, // Set a higher z-index to ensure it's above all other elements
                            color: 'white', // Set text color
                        }}
                    >
                        <Typography
                            variant="h3"
                            component="h1"
                            mb={2}
                            style={{
                                fontWeight: 700,
                                fontSize: '44px',
                                lineHeight: '53.25px',
                            }}
                        >
                            Get approved faster and smarter with AI-based solutions
                        </Typography>

                        <Typography
                            variant="body1"
                            mb={0}
                            ml={12}
                            mr={12}
                            style={{
                                fontWeight: 500,
                                fontSize: '16px',
                                lineHeight: '19.36px',
                            }}
                        >
                            With our AI-powered system, you can bid farewell to manual paperwork and lengthy waiting times.
                        </Typography>

                        <Button
                            onClick={() => setOpen(true)}
                            variant="contained"
                            style={{
                                backgroundColor: "transparent",
                                color: "white",
                                border: "1px solid white",
                                width: "241px",
                                height: "48px",
                                fontWeight: 700,
                                fontSize: '18px',
                                lineHeight: '23.44px',
                                letterSpacing: '5%',
                                textAlign: 'center',
                                position: 'absolute',
                                bottom: '20px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                zIndex: 2,
                            }}
                        >
                            Search MLO
                        </Button>

                    </Box>
                </Box>
            </Container>

            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>Search MLO</DialogTitle>
                <DialogContent>
                    <Box display="flex" flexDirection="column" alignItems="left" md={6} paddingLeft={6} paddingRight={6}>
                        <Box xs={6} marginLeft={0} mt={4} mb={2}>
                            <InputLabel>Select State</InputLabel>
                        </Box>
                        <TextField
                            select
                            value={selectedState}
                            onChange={(e) => setSelectedState(e.target.value)}
                            variant="outlined"
                            fullWidth
                            style={{ marginBottom: '20px', minWidth: '250px' }}
                        >
                            {states.map((state) => (
                                <MenuItem key={state.value} value={state.value}>{state.label}</MenuItem>
                            ))}
                        </TextField>
                        <Button onClick={handleSearch} variant="contained" color="primary"
                            style={{ width: '100%', maxWidth: '759px' }} >
                            Search
                        </Button>
                    </Box>
                    <Box mt={3}>
                        <Grid container spacing={1}>
                            {filteredMloDetails.length === 0 ? (
                                <Box xs={6} marginLeft={24} mt={2}>
                                    <Typography variant="body1" style={{ color: 'red', textAlign: 'center', marginLeft: '10px' }}>
                                        No matching MLOs found
                                    </Typography>
                                </Box>

                            ) : (
                                filteredMloDetails.map((mlo, index) => (
                                    <Grid item xs={12} key={index}>
                                        <Grid
                                            minWidth={'100%'}
                                            item
                                            container
                                            borderRight={{ xs: 0, md: "1px solid #cccccc" }}
                                            position={"relative"}
                                            md={6}
                                        >

                                        </Grid>
                                        <Card style={{ borderRadius: '15px', backgroundColor: '#F5F9FA', marginLeft: '8%', marginRight: '8%' }}>

                                            <CardContent style={{ borderRadius: '15px', backgroundColor: '#F5F9FA', marginLeft: '0%', marginRight: '1%' }}  >
                                                <Grid container spacing={1} alignItems="center">
                                                    {/* First Column: Avatar */}
                                                    <Grid item xs={2} container justifyContent="center" alignItems="flex-start">
                                                        <Box mb={6} >
                                                            <CustomAvtar />
                                                        </Box>
                                                        <Box mb={2} ml={14}>
                                                            <Button
                                                                variant="outlined"
                                                                sx={{
                                                                    fontWeight: 700,
                                                                    fontSize: '12px',
                                                                    lineHeight: '18.23px',
                                                                    textAlign: 'center',
                                                                    color: '#31B9B5',
                                                                    borderColor: '#31B9B5',
                                                                    backgroundColor: 'transparent',
                                                                    '&:hover': {
                                                                        backgroundColor: '#31B9B5',
                                                                        color: '#fff',
                                                                    },
                                                                }}
                                                            >
                                                                Connect with me
                                                            </Button>
                                                        </Box>
                                                    </Grid>

                                                    {/* Second Column: MLO Name and NMLS ID */}
                                                    <Grid item xs={4}>
                                                        <Box mb={10}>
                                                            <Typography variant="h6" sx={{ fontWeight: 400, fontSize: '16px', lineHeight: '20.83px', color: '#31B9B5', }} mb={1}> {mlo.name}</Typography>

                                                            <Typography variant="body2" sx={{ fontWeight: 400, fontSize: '12px', lineHeight: '15.62px', color: '#31B9B5', }} mb={2}> NMLS ID# {mlo.nmlsId}</Typography>


                                                        </Box>
                                                    </Grid>
                                                    {/* Third Column: Company Name, Phone, Email, Website */}
                                                    <Grid item xs={6}>
                                                        <Box>
                                                            <Typography variant="body2" textAlign="right" mt={3} mb={6} sx={{ fontWeight: 700, fontSize: '12px', lineHeight: '15.62px', color: '#31B9B5', }}>{mlo.companyName}</Typography>

                                                            <Box display="flex" alignItems="center" justifyContent="flex-end" mb={1}>
                                                                <Typography variant="body2" textAlign="right" mr={1} sx={{ fontWeight: 400, fontSize: '12px', lineHeight: '15.62px', color: '#31B9B5', }} >{mlo.phone}</Typography>
                                                                <PhoneIcon style={{ width: '13.6px', height: '13.6px' }} />
                                                            </Box>
                                                            <Box display="flex" alignItems="center" justifyContent="flex-end" mb={1}>
                                                                <Typography variant="body2" textAlign="right" mr={1} sx={{ fontWeight: 400, fontSize: '12px', lineHeight: '15.62px', color: '#31B9B5', }}
                                                                >{mlo.email}</Typography>
                                                                <EmailIcon style={{ width: '13.6px', height: '13.6px' }} />
                                                            </Box>
                                                            <Box display="flex" alignItems="center" justifyContent="flex-end" mb={1}>
                                                                <Typography variant="body2" textAlign="right" mr={1} sx={{ fontWeight: 400, fontSize: '12px', lineHeight: '15.62px', color: '#31B9B5', }}
                                                                >{mlo.website}
                                                                </Typography>
                                                                <WebsiteIcon style={{ width: '13.6px', height: '13.6px' }} />
                                                            </Box>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))
                            )}
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>


        </div >
    );
}

export default Banner;

